<template>
    <tableView
        :selectable="selectable"
        :template-info="templateInfo"
        :do-verify="true"
        check-selectablefield="status"
        :do-verify-url="doVerifyUrl"
    />
</template>

<script>
  import axios from "axios";
  import tableView from "@/components/tableView.vue";
  export default {
    name: "assessobj-approval",
    components:{
      tableView
    },
    data(){
      return {
        doVerifyUrl: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assessObj/approval",
        selectable:true,
        templateInfo: {},
        tabList:[]
      }
    },
    mounted(){
      this.knowThis();
    },
    methods:{
      async knowThis() {
        let _this = this;
        console.log(this.$route.name)
        let localIpStr = localStorage.getItem("userLocalIP");
        if (localIpStr == null) localIpStr = "127.0.0.1";
        let jwtSession = localStorage.getItem("lyqtJwt");
        if (jwtSession == null) jwtSession = "";
        await axios({
          url:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module/route/template/" + `${this.$route.name}`,
          headers: {
            "Authorization": "Bearer " + jwtSession,
            "userIP": localIpStr
          },
          method: 'GET'})
          .then(res => {
            console.log("template");
            console.log(res.data.content)
            _this.tabList=res.data.content;
            _this.templateInfo = _this.tabList.pages[0];
            _this.templateInfo.moduleid=_this.tabList.moduleid;
            _this.templateInfo.modulename=_this.tabList.modulename;
            console.log("templateApproval",_this.templateInfo);
          }).catch(err => {
            console.log(err)
          })
      },
    }
  }
</script>

<style scoped>

</style>